﻿import React from 'react';
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';

import { H1 } from '@Elements/Fonts';
import Customers_Table from '@Elements/Customers_Table';

export default function Customerspage(): JSX.Element {
    const [t] = useTranslation();

    return (
        <div className="Page_Content_InnerNarrow">
            <Helmet>
                <title>{`${t('Navigation.Customers')} - InTime`}</title>
            </Helmet>
            <H1>{t('Navigation.Customers')}</H1>
            <Customers_Table />
        </div>
    );
}